import React from 'react';  
import { Redirect, Route } from 'react-router-dom';
import {isAuthenticated} from './AuthCheck';

const AdminRoute = ({ component: Component, ...rest }) =>  (
    <Route
      {...rest}
      render={props =>
        isAuthenticated() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/admin/login",
              state: { from: props.location }
            }}
          />
        )
      }
    />
)

export default AdminRoute;  